import React, { type FunctionComponent, Suspense } from 'react'
import { GridCellImageLoader } from './components/GridCellImageLoader'
import {
  type GridCellImageContentProps,
  GridCellImageContent,
} from './components/GridCellImageContent'

interface Props extends GridCellImageContentProps {}

export const GridCellImage: FunctionComponent<Props> = props => (
  <Suspense fallback={<GridCellImageLoader />}>
    <GridCellImageContent {...props} />
  </Suspense>
)
